import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "./layout";

import Search from "./scenes/search";
import SearchView from "./scenes/search/view";
import Answers from "./scenes/answer/index";
import ViewAnswer from "./scenes/answer/view";
import FileView from "./scenes/answer/view/fileView";
import ListSourcesActive from "./scenes/sources/sourcesActivated";
import ListSourcesPending from "./scenes/sources/sourcesPending";

export default function RfpApp() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/rfp/search" replace />} />
        <Route path="search" element={<Search />} />
        <Route path="search/:id" element={<SearchView />} />
        <Route path="answers/pending" element={<Answers status="pending" />} />
        <Route path="answers/treated" element={<Answers status="treated" />} />
        <Route path="answers/:id" element={<ViewAnswer />} />
        <Route path="answers/:answer_id/file/:file_id" element={<FileView />} />
        <Route path="sources/pending" element={<ListSourcesPending />} />
        <Route path="sources/active" element={<ListSourcesActive />} />
      </Route>
    </Routes>
  );
}
